import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { applyWFH, getWorkFromHomeById, updateWFH } from '../../service/WfhAPI';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import './Wfh.css';
import Loader from '../../StaticComponent/Loader';
import { NotificationTrigger, OnlyNumberSpecialChar } from '../../utils/RegHandling';
import { connect } from 'react-redux';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import _ from 'lodash';
import { encryptStorage } from '../../constant';
import { sendMail } from '../../service/RecruiterApi';
import { getReportingEmpId } from '../../service/DirectorAPI';
import { getS3 } from '../../utils/Download';
import { AES } from 'crypto-js';

function WfhForm({ websocket }) {
    const { wfhId } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    let data = {
        start_date: '',
        end_date: '',
        reason: '',
        status: '',
        comments: '',
    };

    let oldwfData = {
        start_date: '',
        end_date: '',
        reason: '',
        status: '',
        comments: '',
    };

    let details = { role: '', roleId: '', domain: '' };
    const [userDetails, setUserDetails] = useState(details);
    const [breadCrumbsData, setbreadCrumbsData] = useState([]);

    const [wfhData, setwfhData] = useState(data);
    const [oldwfhData, setoldwfhData] = useState(data);
    const [oldData, setoldData] = useState(oldwfData);

    const [startDateValidation, setstartDateValidation] = useState('');
    const [endDateValidation, setendDateValidation] = useState('');
    const [reasonValidation, setreasonValidation] = useState('');
    const [commentsValidation, setCommentsValidation] = useState('');
    const [reportsTo, setReportsTo] = useState();
    const [wfhform, setwfhform] = useState();
    const [oldwfhform, setoldwfhform] = useState();
    const [logs, setLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [wfhUpdate, setwfhUpdate] = useState(false);
    const [wfhEdit, setwfhEdit] = useState(false);
    const [employeeName, setemployeeName] = useState('');
    const [employeeDomain, setemployeeDomain] = useState('');
    const isProfile = window.location.href.includes('IsTeamMember');
    const [submit, setSubmit] = useState('Apply');
    const [formTitle, setFormTitle] = useState('Apply for WFH');

    const [editBack, setEditBack] = useState(false);

    const [disabledCheck, setDisabledCheck] = useState(false);

    useEffect(() => {
        if (state?.way == 'howDoI') {
            setbreadCrumbsData([
                { title: 'Dashboard', path: '/overview', isActive: true },
                { title: `How Do I`, path: ``, isActive: true },
                { title: 'Apply WFH', path: '', isActive: false },
            ]);
        } else {
            setbreadCrumbsData([
                { title: 'Dashboard', path: '/overview', isActive: true },
                { title: `WFH`, path: `/leavewfh?tab=wfh`, isActive: true },
                // { title: formTitle, path: '', isActive: false },
                { title: wfhId ? 'Review WFH Request' : 'Apply WFH', path: '', isActive: false },
            ]);
        }
        setIsLoading(false);
        userDetails.roleId = encryptStorage.getItem('employeeId');
        userDetails.role = encryptStorage.getItem('role');
        userDetails.domain = encryptStorage.getItem('department');
        setUserDetails({ ...userDetails });
        LoadDataEditView();
    }, [wfhId]);

    useEffect(() => {
        if (isProfile) {
            setbreadCrumbsData([
                { title: 'Dashboard', path: '/overview', isActive: true },
                { title: `My Profile`, path: `/profilecontainer?EmpId=${userDetails.roleId}&IsTeamMember=true&tab=Leave`, isActive: true },
                { title: 'Apply WFH', path: '', isActive: false },
            ]);
        }
    }, [isProfile, userDetails.roleId]);

    useEffect(() => {
        let isSame = _.isEqual(oldData, wfhData);

        if (wfhId && isSame) setDisabledCheck(true);
        else if (!isSame) setDisabledCheck(false);
    }, [oldData, wfhData, disabledCheck]);

    const LoadDataEditView = async () => {
        //
        let wfhID = {
            wfhId: wfhId,
        };
        let validReportTo = false;

        if (wfhId) {
            setSubmit('Update & Apply');
            setFormTitle('Edit WFH Details');

            setEditBack(true);

            let responsedata = await getWorkFromHomeById(wfhID);
         switch (encryptStorage.getItem('groupid')) {
             case '1': {
                 validReportTo = true;
                 break;
             }
             case '2': {
                 if (encryptStorage.getItem('employeeId') == responsedata?.data?.ResponseData[0][0]?.emp_id) {
                     validReportTo = true;
                 } else {
                     let request = {
                         login_id: encryptStorage.getItem('employeeId'),
                     };
                     let respdata = await getReportingEmpId(request);


                     for (let i = 0; i < respdata.data.ResponseData[0]?.length; i++) {
                         if (respdata.data.ResponseData[0][i]?.emp_id === responsedata?.data?.ResponseData[0][0]?.emp_id) {
                             validReportTo = true;
                         }
                         //
                     }
                 }
                 break;
             }
             case '3': {
                 if (responsedata?.data?.ResponseData[0][0]?.emp_id == encryptStorage.getItem('employeeId')) validReportTo = true;
                 break;
             }
             default: {
                 navigate('*');
                 break;
             }
         }
         if (validReportTo) {
             setwfhform(responsedata.data.ResponseData[0][0]);
             setoldwfhform(responsedata.data.ResponseData[0][0]);

             setLogs(responsedata.data.logs);
             setReportsTo(responsedata.data.ResponseData[0][0].reports_to);

             let startDate = moment(responsedata.data.ResponseData[0][0].start_date).utc().format('YYYY-MM-DD');
             let endDate = moment(responsedata.data.ResponseData[0][0].end_date).utc().format('YYYY-MM-DD');
             let valiDateobj = {
                 start_date: startDate,
                 end_date: endDate,
                 reason: responsedata.data.ResponseData[0][0].reason,
                 comments: responsedata.data.ResponseData[0][0].comments,
             };
             setwfhData({ ...wfhData, ...valiDateobj });
             setoldwfhData({ ...wfhData, ...valiDateobj });
             setoldData({ ...wfhData, ...valiDateobj });
             setemployeeName(responsedata.data.ResponseData[0][0].emp_name);
             setemployeeDomain(responsedata.data.ResponseData[0][0].domain);
             let a =
                 userDetails.roleId === responsedata.data.ResponseData[0][0].reports_to
                     ? setwfhEdit(false)
                     : userDetails.roleId === responsedata.data.ResponseData[0][0].emp_id &&
                       responsedata.data.ResponseData[0][0].emp_id == 'Pending'
                     ? setwfhEdit(true)
                     : wfhId === undefined
                     ? setwfhEdit(true)
                     : setwfhEdit(false);
         } else {
             navigate('/', { state: { hideNav: false } });
         }
        } else {
            setwfhEdit(true);
        }
        setIsLoading(true);
    };
    const OnValueChange = (e) => {
        setwfhData({ ...wfhData, [e.target.name]: e.target.value });
    };

    const wfhValidation = (value = 'Apply') => {
        //
        let result = true;
        if (wfhData.start_date == '') {
            setstartDateValidation('Select the start date');
            result = false;
        }
        if (wfhData.end_date == '') {
            setendDateValidation('Select the end date');
            result = false;
        } else if (wfhData.end_date < wfhData.start_date) {
            setendDateValidation('Please select a valid end date');
            result = false;
        }
        if (wfhData.reason.trim() == '') {
            setreasonValidation('Reason is required');
            result = false;
        } else {
            let checkregex = OnlyNumberSpecialChar(wfhData.reason.trim());
            if (checkregex) {
                result = false;
                setreasonValidation('Please enter a valid reason');
            } else {
                setreasonValidation('');
            }
        }
        if (result && value == 'Apply') applyClicked();
        else if (result && value == 'Approved') ApproveRequest('Approved');
        else if (result && value == 'Updated and Approved') ApproveRequest('Updated and Approved');
    };
    const formatDateForTimezone = (dateString, timezone) => {
        // Parse the input date string and add one day to compensate for the shift
        const date = new Date(dateString);
        date.setDate(date.getDate() + 1);
        
        // Format the date as YYYY/MM/DD in the specified timezone
        const options = { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: timezone };
        const formattedDate = date.toLocaleDateString('en-US', options);
        
        // Rearrange the date parts to YYYY/MM/DD format
        const [month, day, year] = formattedDate.split('/');
        return `${year}/${month}/${day}`;
    };
    const applyClicked = async () => {
        //
        setIsLoading(false);
        if (wfhUpdate) {
            ApproveRequest('Pending');
        } else {
            let insertData = {
                start_date: wfhData.start_date,
                end_date: wfhData.end_date,
                reason: wfhData.reason,
                empId: userDetails.roleId,
            };
            let response = await applyWFH(insertData);
            let email = response.data.Email;
            if (response.data.ResponseData === 'Successfully inserted') {
                //;

                NotificationTrigger(
                    {
                        title: 'Wfh',
                        message: 'WFH request was raised',
                        route: `wfhform/${response?.data?.wfhId}`,
                        state: { state: { switchTab: 'allwfh' } },
                        to_employee: [response?.data?.reportsTo],
                        by: userDetails.roleId,
                    },
                    [response?.data?.reportsTo],
                    websocket
                ).then((res) => {
                    // if(!isProfile) navigate(`/leavewfh?tab=${state.switchTab}`)
                    // else  window.location.href = `/wfhform?IsTeamMember=true`
                    if (!isProfile) {
                        if (state?.switchTab == null) {
                            navigate(`/leavewfh`);
                        } else {
                            navigate(`/leavewfh?tab=${state?.switchTab}`);
                        }
                    } else {
                        window.location.href = `/profilecontainer?EmpId=${userDetails.roleId}&tab=Leave&IsTeamMember=true`;
                    }

                    sessionStorage.setItem('showToast', 'Applied Succesfully');
                    sessionStorage.setItem('ToastColour', 'green');
                    sessionStorage.setItem('ToastParagraph', 'WFH Applied Succesfully');
                });
                const timezone = userDetails.domain === 'India' ? 'Asia/Kolkata' : 'America/Chicago';
                let startdate = formatDateForTimezone(email.From, timezone);
                let enddate = formatDateForTimezone(email.To, timezone);

                let content = {
                    Subject: `Work From Home request - ${email.teamMemberName}`,
                    body: `

                    <div style="width: 100%; font-family:'Open Sans'; margin-left: auto; margin-right: auto; max-width: 960px;">
                    <h3 style="font-family:'Segoe UI'; ">Hi ${email.teamMemberName},</h3> 
                    <p style="font-family:'Segoe UI'; margin-bottom: 24px;">Your <strong>Work From Home</strong> request has been submitted for approval to <strong>${email.ManagerName}.</strong> You will be notified on the approval status </p>
                   <div style="box-shadow: 10px 10px 12px 4px #F4F4F4; padding:4px 16px; border: 1px solid #DEBA3C;
                   border-radius: 8px;">
                   <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Request ID</strong><span style="display: block;width: 45%;"><a href="https://hive.avasoft.com/wfhform/${email.RequestID}">${email.RequestID}</a></span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">From Date</strong><span style="display: block;width: 45%;">${startdate}</span></p>
                    <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">To Date</strong><span style="display: block;width: 45%;">${enddate}</span></p>
       <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Reason</strong><span style="display: block;width: 45%;">${email.Reason}</span></p>
                 
                   </div>
                  
                   
                  </div>


                   `,
                    to: [email.teamMemberEmail],
                    cc: [email.ManagerEmail],
                    //to: ['Nivetha.mu@avasoft.com'],
                    from: 'hrcommunications@avasoft.com',

                };
                sendMail(content);
            }
            else if (response.data.ResponseData === 'Date already exist') {
                if (state?.switchTab == null) {
                    navigate(`/leavewfh`);
                } else {
                    navigate(`/leavewfh?tab=${state?.switchTab}`);
                }
                sessionStorage.setItem('showToast', 'Request already exists');
                sessionStorage.setItem('ToastColour', 'Cross');
                sessionStorage.setItem('ToastParagraph', 'A WFH request has already been raised for the selected date(s)');
            }
            else {
                if (state?.switchTab == null) {
                    navigate(`/leavewfh`);
                } else {
                    navigate(`/leavewfh?tab=${state?.switchTab}`);
                }
                sessionStorage.setItem('showToast', 'Something went wrong');
                sessionStorage.setItem('ToastColour', 'Cross');
                sessionStorage.setItem('ToastParagraph', response.data.ErrorMessage || 'Unable to submit your WFH request. Please try again.');
            }
        }
        setIsLoading(true);
    };
    const RejectRequest = async (id) => {
        // 
        if (wfhData.comments === '' || wfhData.comments === null) {
            setCommentsValidation('Comments for rejection is required ');
            return false;
        } else if (wfhData.comments) {
            let checkregex = OnlyNumberSpecialChar(wfhData.comments.trim());

            if (checkregex) {
                setCommentsValidation('Please enter a valid reason');
                return false;
            }
        }
        setIsLoading(false);
        let obj = {
            status: id,
            approved_by_id: userDetails.roleId,
            wfhId: wfhId,
            comments: wfhData.comments,
            empId: userDetails.roleId,
        };

        let updateResult = await updateWFH({ ...obj, status: id });
        let email = updateResult.data.Email;
        if (updateResult.data.ResponseData === 'Successfully updated') {
            setIsLoading(true);

            NotificationTrigger(
                {
                    title: 'Wfh',
                    message: 'Your WFH request was rejected',
                    route: `wfhform/${wfhId}`,
                    state: { state: { switchTab: 'allwfh' } },
                    to_employee: [updateResult.data.empId],
                    by: userDetails.roleId,
                },
                [updateResult.data.empId],
                websocket
            ).then((res) => {
                // if (!isProfile) navigate(`/leavewfh?tab=${state.switchTab}`)
                // else window.location.href = `/wfhform?IsTeamMember=true`
                if (!isProfile) {
                    if (state?.switchTab == null) {
                        navigate(`/leavewfh`);
                    } else {
                        navigate(`/leavewfh?tab=${state?.switchTab}`);
                    }
                    //navigate(`/leavewfh?tab=${state.switchTab}`);
                } else {
                    window.location.href = `/profilecontainer?EmpId=${userDetails.roleId}&tab=Leave&IsTeamMember=true`;
                }

                sessionStorage.setItem('showToast', 'Rejected Succesfully');
                sessionStorage.setItem('ToastColour', 'Cross');
                sessionStorage.setItem('ToastParagraph', 'WHF Rejected Succesfully');
            });
            let startdate = moment(email.From).format('YYYY-MM-DD');
            let enddate = moment(email.To).format('YYYY-MM-DD');
            let content = {
                Subject: `Work From Home request has been Rejected - ${email.teamMemberName}`,
                body: `

                <div style="width: 100%; font-family:'Open Sans'; margin-left: auto; margin-right: auto; max-width: 960px;">
                <h3 style="font-family:'Segoe UI'; ">Hi ${email.teamMemberName},</h3> 
                <p style="font-family:'Segoe UI'; margin-bottom: 24px;">Your <strong>Work From Home</strong> request was updated as  <strong>Rejected</strong> by<strong> ${email.ManagerName
                }</strong> </p>
               <div style="box-shadow: 10px 10px 12px 4px #F4F4F4; padding:4px 16px; border: 1px solid #DEBA3C;
               border-radius: 8px;">
               <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Request ID</strong><span style="display: block;width: 45%;"><a href="https://hive.avasoft.com/wfhform/${email.RequestID
               }">${email.RequestID}</a></span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">From Date</strong><span style="display: block;width: 45%;">${startdate}</span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">To Date</strong><span style="display: block;width: 45%;">${enddate}</span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Reason</strong><span style="display: block;width: 45%;">${email.Reason
                }</span></p>
                <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Status</strong><span style="display: block;width: 45%;">Rejected</span></p>
   <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Comments</strong><span style="display: block;width: 45%;">${email.Comments == null ? '-' : email.Comments
   }</span></p>
             
               </div>
              
               
              </div>


               `,
                to: [email.teamMemberEmail],
                cc: [email.ManagerEmail],
                // to: ['Nivetha.mu@avasoft.com'],
                 from: 'hrcommunications@avasoft.com',

            };
            sendMail(content);
        }
    };
    const ApproveRequest = async (value) => {
        //
        let result = true;
        if (wfhData.start_date == '') {
            setstartDateValidation('Start Date is required');
            result = false;
        }
        if (wfhData.end_date == '') {
            setendDateValidation('End Date is required');
            result = false;
        }
        if (wfhData.end_date < wfhData.start_date) {
            setendDateValidation('Select the valid Date');
            result = false;
        }
        if (wfhData.reason == '') {
            setreasonValidation('Reason is required');
            result = false;
        }
        if (result) {
            setIsLoading(false);
            let obj =
                value !== 'Pending'
                    ? {
                          status: `${value}`,
                          approved_by_id: userDetails.roleId,
                          wfhId: wfhId,
                          comments: wfhData.comments,
                          empId: userDetails.roleId,
                      }
                    : {
                          status: `${value}`,
                          wfhId: wfhId,
                          reason: wfhData.reason,
                          empId: userDetails.roleId,
                      };
            let newobj = { ...obj, ...wfhData };

            let isSame = _.isEqual(oldData, wfhData);

            if (!isSame || value !== 'Pending') {
                //debugger
                let updateResult = await updateWFH({ ...newobj, status: value });
                let email = updateResult.data?.Email;
                let startdate = moment(email?.From).format('YYYY-MM-DD');
                let enddate = moment(email?.To).format('YYYY-MM-DD');
                //
                if (updateResult.data.ResponseData === 'Successfully updated') {
                    setIsLoading(true);
                    //;
                    if (value !== 'Pending') {
                        NotificationTrigger(
                            {
                                title: 'Wfh',
                                message: `Your WFH request was ${value}`,
                                route: `wfhform/${wfhId}`,
                                state: { state: { switchTab: 'allwfh' } },
                                to_employee: [updateResult.data?.empId],
                                by: userDetails.roleId,
                            },
                            [updateResult.data.empId],
                            websocket
                        ).then((res) => {
                            //;
                            // navigate(`/leavewfh?tab=${state.switchTab}`)
                            if (!isProfile) {
                                if (state?.switchTab == null) {
                                    navigate(`/leavewfh`);
                                } else {
                                    navigate(`/leavewfh?tab=${state?.switchTab}`);
                                }
                                //navigate(`/leavewfh?tab=${state.switchTab}`);
                            } else {
                                window.location.href = `/profilecontainer?EmpId=${userDetails.roleId}&tab=Leave&IsTeamMember=true`;
                            }
                            sessionStorage.setItem('showToast', value + ' Succesfully');
                            sessionStorage.setItem('ToastColour', 'green');
                            sessionStorage.setItem('ToastParagraph', 'WHF' + value + 'Succesfully');
                        });
                        // ;
                        let content = {
                            Subject: `Work From Home request has been ${value}  - ${email.teamMemberName}`,
                            body: `
            
                            <div style="width: 100%; font-family:'Open Sans'; margin-left: auto; margin-right: auto; max-width: 960px;">
                            <h3 style="font-family:'Segoe UI'; ">Hi ${email.teamMemberName},</h3> 
                            <p style="font-family:'Segoe UI'; margin-bottom: 24px;"><strong>Work From Home</strong> request was <strong>${value}</strong> by<strong> ${email.ManagerName
                            }</strong> </p>
                           <div style="box-shadow: 10px 10px 12px 4px #F4F4F4; padding:4px 16px; border: 1px solid #DEBA3C;
                           border-radius: 8px;">
                           <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Request ID</strong><span style="display: block;width: 45%;"><a href="https://hive.avasoft.com/wfhform/${email.RequestID
                           }">${email.RequestID}</a></span></p>
                            <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">From Date</strong><span style="display: block;width: 45%;">${startdate}</span></p>
                            <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">To Date</strong><span style="display: block;width: 45%;">${enddate}</span></p>
                            <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Reason</strong><span style="display: block;width: 45%;">${email.Reason
                            }</span></p>
                            <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Status</strong><span style="display: block;width: 45%;">${value}</span></p>
               <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px;align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Comments</strong><span style="display: block;width: 45%;">${email.Comments == null ? '-' : email.Comments
               }</span></p>
                         
                           </div>
                          
                           
                          </div>
            
            
                           `,
                            to: [email.teamMemberEmail],
                            cc: [email.ManagerEmail],
                            //to: ['Nivetha.mu@avasoft.com'],
                            from: 'hrcommunications@avasoft.com',

                        };
                        sendMail(content);
                    } else {
                        NotificationTrigger(
                            {
                                title: 'Wfh',
                                message: `The WFH request has been updated`,
                                route: `wfhform/${wfhId} `,
                                state: { state: { switchTab: 'wfh' } },
                                to_employee: [reportsTo],
                                by: userDetails.roleId,
                            },
                            [reportsTo],
                            websocket
                        ).then((res) => {
                            // navigate(`/ leavewfh ? tab = ${state.switchTab} `)
                            if (!isProfile) {
                                if (state?.switchTab == null) {
                                    navigate(`/leavewfh`);
                                } else {
                                    navigate(`/leavewfh?tab=${state?.switchTab}`);
                                }
                            } else {
                                window.location.href = `/profilecontainer?EmpId=${userDetails.roleId}&tab=Leave&IsTeamMember=true`;
                            }

                            if (value == 'Pending') {
                                sessionStorage.setItem('showToast', 'Updated Succesfully');
                                sessionStorage.setItem('ToastColour', 'green');
                                sessionStorage.setItem('ToastParagraph', 'WHF Updated Succesfully');
                            } else {
                                sessionStorage.setItem('showToast', value + ' Succesfully');
                                sessionStorage.setItem('ToastColour', 'green');
                                sessionStorage.setItem('ToastParagraph', 'WHF' + value + 'Succesfully');
                            }
                        });
                        let content = {
                            Subject: `Work From Home request - ${email.teamMemberName}`,
                            body: `
            
                            <div style="width: 100%; font-family:'Open Sans'; margin-left: auto; margin-right: auto; max-width: 960px;">
                            <h3 style="font-family:'Segoe UI'; ">Hi ${email.teamMemberName},</h3> 
                            <p style="font-family:'Segoe UI'; margin-bottom: 24px;">Your <strong>Work From Home</strong> request has been updated and submitted for approval to <strong>${email.ManagerName
                            }.</strong> You will be notified on the approval status </p>
                           <div style="box-shadow: 10px 10px 12px 4px #F4F4F4; padding:4px 16px; border: 1px solid #DEBA3C;
                           border-radius: 8px;">
                           <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Request ID</strong><span style="display: block;width: 45%;"><a href="https://hive.avasoft.com/wfhform/${email.RequestID
                           }">${email.RequestID}</a></span></p>
                            <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">From Date</strong><span style="display: block;width: 45%;">${startdate}</span></p>
                            <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">To Date</strong><span style="display: block;width: 45%;">${enddate}</span></p>
                            <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Reason</strong><span style="display: block;width: 45%;">${email.Reason
                            }</span></p>
                            <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Status</strong><span style="display: block;width: 45%;">Submitted</span></p>
               <p style="font-family:'Segoe UI'; display: flex; margin: 0; padding: 8px 0px; border-bottom: 1px solid #e3e3e3; align-items: center;"><strong style="display: block;width: 50%; padding-right: 5%;">Comments</strong><span style="display: block;width: 45%;">${email.Comments == null ? '-' : email.Comments
               }</span></p>
                         
                           </div>
                          
                           
                          </div>
            
            
                           `,
                            to: [email.teamMemberEmail],
                            cc: [email.ManagerEmail],
                            // to: ['Nivetha.mu@avasoft.com'],
                            from: 'hrcommunications@avasoft.com',

                        };
                        sendMail(content);
                    }
                }
                setIsLoading(true);
            } else {
                setIsLoading(true);
            }
        }
    };
    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="container-fluid mt-5">
                <div className="mt-5"></div>
                <div className="row justify-content-center ">
                    <div className="col-md-9">
                        <div className="row ">
                            {wfhEdit ? (
                                <div className="col-md-8 pt-3 rounded-3 bg-white px-4">
                                    <BreadCrumbs data={breadCrumbsData} />
                                    <p className="font-15 mb-3 leave-header-color bold-text">
                                        <span>
                                            <a
                                                // href={isProfile ?
                                                //     `/ profilecontainer ? EmpId = ${ userDetails.roleId }& tab=Leave & IsTeamMember=true` :
                                                //     null}

                                                onClick={() => {
                                                    if (editBack) setwfhEdit(!wfhEdit);
                                                    else if (!isProfile) {
                                                        if (state?.switchTab == null) {
                                                            navigate(`/leavewfh`);
                                                        } else {
                                                            navigate(`/leavewfh?tab=${state?.switchTab}`);
                                                        }
                                                        // navigate(`/leavewfh?tab=${state.switchTab}`);
                                                    } else
                                                        window.location.href = `/profilecontainer?EmpId=${userDetails.roleId}&tab=Leave&IsTeamMember=true`;
                                                }}
                                            >
                                                <img src="/Images/back-arrow.svg" className="me-3 " alt="back-arrow" />
                                            </a>
                                        </span>
                                        {wfhEdit ? formTitle : 'WFH Details'}
                                    </p>
                                    <h1 className="form-label hive-form-label mt-5">Date Range</h1>
                                    <div className="row mb-4">
                                        <div className="col-md-3">
                                            <label className="form-label hive-form-label leave-date-label-color" htmlFor="start-date">
                                                Start Date <span className="required">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="start-date"
                                                name="start_date"
                                                value={wfhData.start_date}
                                                onChange={(e) => {
                                                    setstartDateValidation('');
                                                    OnValueChange(e);
                                                }}
                                            />
                                            <label className="text-danger">{startDateValidation}</label>
                                        </div>
                                        <div
                                            className="col-md-1 align-self-end d-flex justify-content-center"
                                            style={{ 'margin-bottom': '5%' }}
                                        >
                                            <img src="/Images/right-arrow.svg" alt="right-arrow" />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label hive-form-label leave-date-label-color" htmlFor="end-date">
                                                End Date <span className="required">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="end-date"
                                                name="end_date"
                                                value={wfhData.end_date}
                                                onChange={(e) => {
                                                    setendDateValidation('');
                                                    OnValueChange(e);
                                                }}
                                            />
                                            <label className="text-danger">{endDateValidation}</label>
                                        </div>
                                    </div>
                                    <label className="form-label hive-form-label" htmlFor="wfh-reason">
                                        Reason for WFH <span className="required">*</span>
                                    </label>
                                    <textarea
                                        maxLength={1000}
                                        className="form-control hive-form-control leaveform-commentbox"
                                        id="wfh-reason"
                                        placeholder="Enter the reason for WFH "
                                        name="reason"
                                        value={wfhData.reason}
                                        onChange={(e) => {
                                            setreasonValidation('');
                                            OnValueChange(e);
                                        }}
                                    />
                                    <label className="text-danger">{reasonValidation}</label>
                                    {userDetails.roleId == reportsTo ? (
                                        <div className="text-end my-5">
                                            <a
                                                onClick={() => {
                                                    setwfhData(oldwfhData);
                                                    setwfhform(oldwfhform);
                                                    setwfhEdit(false);
                                                    setwfhUpdate(false);
                                                }}
                                            >
                                                <button className="btn cancel-button bold-text font-13 me-3">Cancel</button>
                                            </a>
                                            <button
                                                disabled={disabledCheck}
                                                className="btn medium-text font-12 primary-button"
                                                onClick={() => {
                                                    wfhValidation('Updated and Approved');
                                                }}
                                            >
                                                Update and Approve
                                            </button>
                                        </div>
                                    ) : userDetails.roleId == wfhform?.emp_id || wfhId === undefined ? (
                                        <>
                                            <div className="text-end my-5">
                                                <a
                                                    onClick={() => {
                                                        // let checkAssign = !isProfile ? navigate(`/ leavewfh ? tab = ${ state.switchTab } `) : null

                                                        if (!isProfile) {
                                                            if (state?.switchTab == null) {
                                                                navigate(`/leavewfh`);
                                                            } else {
                                                                navigate(`/leavewfh?tab=${state?.switchTab}`);
                                                            }
                                                        } else
                                                            window.location.href = `/profilecontainer?EmpId=${userDetails.roleId}&tab=Leave&IsTeamMember=true`;
                                                    }}
                                                >
                                                    <button className="btn cancel-button bold-text font-14 me-3">Cancel</button>
                                                </a>
                                                <button
                                                    className="btn medium-text font-14 primary-button"
                                                    disabled={submit != 'Apply' ? disabledCheck : false}
                                                    onClick={() => {
                                                        wfhValidation();
                                                    }}
                                                >
                                                    {submit}
                                                </button>
                                            </div>{' '}
                                        </>
                                    ) : null}
                                </div>
                            ) : (
                                <div className="col-md-9 pt-3 rounded-3 leave-rounded-7 bg-white px-4">
                                    <BreadCrumbs data={breadCrumbsData} />
                                    <div className="custom-leave-panel">
                                        <p className="font-15 mb-3 leave-header-color bold-text">
                                            <span>
                                                <a
                                                    onClick={() => {
                                                        if (!isProfile) {
                                                            if (state?.switchTab == null) {
                                                                navigate(`/leavewfh`);
                                                            } else {
                                                                navigate(`/leavewfh?tab=${state?.switchTab}`);
                                                            }
                                                        } else
                                                            window.location.href = `/profilecontainer?EmpId=${userDetails.roleId}&tab=Leave&IsTeamMember=true`;
                                                    }}
                                                >
                                                    <img src="/Images/back-arrow.svg" className="me-3 " alt="back-arrow" />
                                                </a>
                                            </span>
                                            Review Request
                                        </p>
                                        <div className="row mb-5 mt-4">
                                            <div className="col-md-8 align-items-center d-flex">
                                                <img
                                                    src="/Images/logo-person-user-person-icon.jpg"
                                                    className="leave-profile-img me-3"
                                                    alt="img"
                                                />
                                                <div>
                                                    <p className="font-16 regular-text leave-header-color mb-0">{employeeName}</p>
                                                    <p className=" font-14 regular-text leave-date-label-color mb-0">{employeeDomain}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <p className="bold-text font-20 leave-type-color mb-0">WFH</p>
                                            <span className={`${wfhform?.color} medium - text font - 12 rounded - 2`}>
                                                {' '}
                                                {wfhform?.status == 'Pending' ? (
                                                    <img src="/Images/clock.svg" alt="clockicon" className="me-1" />
                                                ) : null}
                                                {wfhform?.status}
                                            </span>
                                        </div>
                                        <div className="row justify-content-between align-items-end mb-4">
                                            <div className="col-md-8">
                                                <div className="row align-items-center justify-content-between">
                                                    <div className="col-md-5 pe-0">
                                                        <div className="border leave-border rounderd-3">
                                                            <h3 className="bold-text font-28 leave-type-color">
                                                                {moment(wfhform?.start_date).utc().format('DD')}{' '}
                                                                <span className="font-14 regular-text leave-label-color">
                                                                    {moment(wfhform?.start_date).utc().format("MMM' YY")}
                                                                </span>
                                                            </h3>
                                                            <h5 className="regular-text leave-type-color font-14">
                                                                {moment(wfhform?.start_date).utc().format('dddd')}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-1 p-0 text-center">
                                                        <img src="/Images/right-arrow.svg" alt="Icon" />
                                                    </div>
                                                    <div className="col-md-5 ps-0">
                                                        <div className="border leave-border rounderd-3">
                                                            <h3 className="bold-text font-28 leave-type-color ">
                                                                {moment(wfhform?.end_date).utc().format('DD')}{' '}
                                                                <span className="font-14 regular-text leave-label-color">
                                                                    {moment(wfhform?.end_date).utc().format("MMM' YY")}
                                                                </span>
                                                            </h3>
                                                            <h5 className="regular-text leave-type-color font-14">
                                                                {moment(wfhform?.end_date).utc().format('dddd')}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3  justify-content-end align-items-end">
                                                <div className="text-end">
                                                    {(userDetails.roleId == reportsTo && wfhform?.status === 'Pending') ||
                                                    (userDetails.roleId == wfhform?.emp_id &&
                                                        wfhform?.status === 'Pending' &&
                                                        wfhform?.status != 'Approved' &&
                                                        wfhform?.status != 'Revoked') ? (
                                                        <>
                                                            {' '}
                                                            <h3 className="medium-text leave-days-requested-color font-15 mb-0">
                                                                {wfhform?.work_days_count} Work Days Requested
                                                            </h3>
                                                            <button
                                                                onClick={() => {
                                                                    setwfhEdit(true);
                                                                    setwfhUpdate(true);
                                                                }}
                                                                className="btn mt-2 leave-edit-request w-100 medium-text font-13"
                                                            >
                                                                <img src="/Images/edit-request-icon.svg" alt="Edit-icon" className="me-2" />
                                                                Edit
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <h3
                                                            style={{ height: '18px' }}
                                                            className="medium-text leave-days-requested-color font-15 mb-0"
                                                        >
                                                            {wfhform?.work_days_count} Work Days Requested
                                                        </h3>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="col-md-6"></div>
                                        </div>
                                        {userDetails.roleId == reportsTo && wfhform?.status == 'Pending' ? (
                                            <>
                                                <label className="mb-1 regular-text font-15 mt-3" htmlFor="wfh-reason">
                                                    Reason for WFH <span className="required">*</span>
                                                </label>
                                                <textarea
                                                    disabled
                                                    className="form-control custom-comment-box leave-comment-box medium-text font-12"
                                                    id="wfh-reason"
                                                    placeholder="Enter the reason for WFH "
                                                    name="reason"
                                                    value={wfhData.reason}
                                                    onChange={(e) => OnValueChange(e)}
                                                />
                                                <label className="mb-1 regular-text font-15 mt-3" htmlFor="wfh-reason">
                                                    Reason for Rejection <span className="required"></span>
                                                </label>
                                                <textarea
                                                    maxLength={255}
                                                    className="form-control custom-textarea custom-textfield"
                                                    id="wfh-reason-rejection"
                                                    placeholder="Enter Comments Here"
                                                    name="comments"
                                                    value={wfhData.comments}
                                                    onChange={(e) => {
                                                        setstartDateValidation('');
                                                        OnValueChange(e);
                                                    }}
                                                />
                                            </>
                                        ) : wfhform?.status == 'Rejected' ? (
                                            <>
                                                <label className="mb-1 regular-text font-15 mt-3" htmlFor="wfh-reason">
                                                    Reason for WFH <span className="required">*</span>
                                                </label>
                                                <textarea
                                                    disabled
                                                    className="form-control custom-comment-box leave-comment-box medium-text font-12"
                                                    id="wfh-reason"
                                                    placeholder="Enter the reason for WFH "
                                                    name="reason"
                                                    value={wfhData.reason}
                                                    onChange={(e) => OnValueChange(e)}
                                                />

                                                <label className="mb-1 regular-text font-15 mt-3" htmlFor="wfh-reason">
                                                    Reason for Rejection <span className="required"></span>
                                                </label>
                                                <textarea
                                                    disabled
                                                    className="form-control custom-textarea custom-textfield"
                                                    id="wfh-reason-rejection"
                                                    placeholder="Enter reason for rejection"
                                                    name="comments"
                                                    value={wfhData.comments}
                                                    onChange={(e) => {
                                                        setendDateValidation('');
                                                        OnValueChange(e);
                                                    }}
                                                />
                                            </>
                                        ) : wfhform?.status ? (
                                            <>
                                                <label className="mb-1 regular-text font-15 mt-3" htmlFor="wfh-reason">
                                                    Reason for WFH <span className="required">*</span>
                                                </label>
                                                <textarea
                                                    disabled
                                                    className="form-control custom-comment-box leave-comment-box medium-text font-12"
                                                    id="wfh-reason"
                                                    placeholder="Enter the reason for WFH "
                                                    name="reason"
                                                    value={wfhData.reason}
                                                    onChange={(e) => {
                                                        setreasonValidation('');
                                                        OnValueChange(e);
                                                    }}
                                                />
                                            </>
                                        ) : null}
                                        <label className="text-danger">{commentsValidation}</label>
                                        <div className="d-flex justify-content-between align-items-center mb-4 mt-4">
                                            <a
                                                onClick={() => {
                                                    // let checkAssign = !isProfile ? navigate(`/ leavewfh ? tab = ${ state.switchTab } `) : null
                                                    if (!isProfile) {
                                                        if (state?.switchTab == null) {
                                                            navigate(`/leavewfh`);
                                                        } else {
                                                            navigate(`/leavewfh?tab=${state?.switchTab}`);
                                                        }
                                                    } else
                                                        window.location.href = `/profilecontainer?EmpId=${userDetails.roleId}&tab=Leave&IsTeamMember=true`;
                                                }}
                                            >
                                                <button className="btn hive-btn-secondary p-0">Cancel</button>
                                            </a>
                                            <div>
                                                {userDetails.roleId == reportsTo && wfhform?.status === 'Pending' ? (
                                                    <>
                                                        <button
                                                            onClick={() => {
                                                                RejectRequest('Rejected');
                                                            }}
                                                            className="btn secondary-button leave-reject-button medium-text font-13 me-2"
                                                        >
                                                            Reject Request
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                ApproveRequest('Approved');
                                                            }}
                                                            className="btn primary-button leave-approve-button medium-text font-13"
                                                        >
                                                            Approve Request
                                                        </button>
                                                    </>
                                                ) : wfhform?.status === 'Approved' &&
                                                  userDetails.role !== 'Hr' &&
                                                  userDetails.role !== 'Team Member' ? (
                                                    <button
                                                        onClick={() => {
                                                            ApproveRequest('Revoked');
                                                        }}
                                                        className="btn hive-btn-primary"
                                                    >
                                                        Revoke
                                                    </button>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="col-md-3 ">
                                {logs?.length > 0 ? (
                                    <div className="bg-white mb-3 px-3 rounded-3 py-3">
                                        <p className="bold-text leave-header-color font-15">Version History</p>
                                        <ul className="custom-bullets list-unstyled mb-0">
                                            {logs.map((log) => {
                                                return (
                                                    <li className="font-13 regular-text pb-3 leave-days-requested-color version-history ">
                                                        {log.id == 1 ? (
                                                            <>
                                                                <p className="mb-0">{log.actions}</p>
                                                                <span>{moment(log.created_at).utc().format('MMMM DD, YYYY')}</span>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <p className="mb-0">
                                                                    {log.emp_name} {log.actions}
                                                                </p>
                                                                <span>{moment(log.created_at).utc().format('MMMM DD, YYYY')}</span>
                                                            </>
                                                        )}
                                                    </li>
                                                );
                                            })}
                                            {/* <li className="font-13 regular-text pb-3 leave-days-requested-color version-history "><p className="mb-0">Request Submitted on </p><span>March 20, 2022</span></li> */}
                                        </ul>
                                    </div>
                                ) : null}
                                <div className="leave-policy-background leave-rounded-7 px-3 py-4">
                                    <a
                                        href={getS3("https://ava-hive-prod-image-s3.s3.ap-south-1.amazonaws.com/AVA Leave policy.pdf")}
                                        target="_blank"
                                        className="leave-policy-color bold-text font-15"
                                    >
                                        Review our Employee Leave Policies
                                        <span>
                                            <img src="/Images/leave-policy-arrow.svg" className="me-2" alt="" />
                                        </span>
                                    </a>
                                    <img src="/Images/leave-policy.svg" alt="Arrow" width="100%" className="mb-4 mt-4" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
function mapStateToProps(state) {
    return {
        websocket: state.webSocketAPI,
    };
}
export default connect(mapStateToProps)(WfhForm);
